export default __webpack_public_path__ + "static/media/support.9ce396ff.svg";